/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetInviteUrl,
  FleetInviteUrlCreateInput,
  FleetInviteUrlsParams,
  FleetMember,
  FleetMembershipCreateInput,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Fleet Membership by Invite
 */
export const useFleetInvite = (
    fleetMembershipCreateInput: MaybeRefOrGetter<FleetMembershipCreateInput>,
 signal?: AbortSignal
) => {
      fleetMembershipCreateInput = toValue(fleetMembershipCreateInput);

      return axiosClient<FleetMember>(
      {url: `/fleets/use-invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetMembershipCreateInput, signal
    },
      );
    }




export const getUseFleetInviteMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof useFleetInvite>>, TError,{data: FleetMembershipCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof useFleetInvite>>, TError,{data: FleetMembershipCreateInput}, TContext> => {

const mutationKey = ['useFleetInvite'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof useFleetInvite>>, {data: FleetMembershipCreateInput}> = (props) => {
          const {data} = props ?? {};

          return  useFleetInvite(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UseFleetInviteMutationResult = NonNullable<Awaited<ReturnType<typeof useFleetInvite>>>
    export type UseFleetInviteMutationBody = FleetMembershipCreateInput
    export type UseFleetInviteMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Create Fleet Membership by Invite
 */
export const useUseFleetInvite = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof useFleetInvite>>, TError,{data: FleetMembershipCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof useFleetInvite>>,
        TError,
        {data: FleetMembershipCreateInput},
        TContext
      > => {
      return useMutation(getUseFleetInviteMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Fleet Invite Url
 */
export const createFleetInviteUrl = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetInviteUrlCreateInput: MaybeRefOrGetter<FleetInviteUrlCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetInviteUrlCreateInput = toValue(fleetInviteUrlCreateInput);

      return axiosClient<FleetInviteUrl>(
      {url: `/fleets/${fleetSlug}/invite-urls`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetInviteUrlCreateInput, signal
    },
      );
    }




export const getCreateFleetInviteUrlMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetInviteUrl>>, TError,{fleetSlug: string;data: FleetInviteUrlCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetInviteUrl>>, TError,{fleetSlug: string;data: FleetInviteUrlCreateInput}, TContext> => {

const mutationKey = ['createFleetInviteUrl'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetInviteUrl>>, {fleetSlug: string;data: FleetInviteUrlCreateInput}> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetInviteUrl(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetInviteUrlMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetInviteUrl>>>
    export type CreateFleetInviteUrlMutationBody = FleetInviteUrlCreateInput
    export type CreateFleetInviteUrlMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Create Fleet Invite Url
 */
export const useCreateFleetInviteUrl = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetInviteUrl>>, TError,{fleetSlug: string;data: FleetInviteUrlCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetInviteUrl>>,
        TError,
        {fleetSlug: string;data: FleetInviteUrlCreateInput},
        TContext
      > => {
      return useMutation(getCreateFleetInviteUrlMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Invite Urls List
 */
export const fleetInviteUrls = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInviteUrlsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetInviteUrl[]>(
      {url: `/fleets/${fleetSlug}/invite-urls`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetInviteUrlsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInviteUrlsParams>,) => {
    return [
    'fleets',fleetSlug,'invite-urls', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetInviteUrlsQueryOptions = <TData = Awaited<ReturnType<typeof fleetInviteUrls>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInviteUrlsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInviteUrls>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInviteUrlsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInviteUrls>>> = ({ signal }) => fleetInviteUrls(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInviteUrls>>, TError, TData>
}

export type FleetInviteUrlsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInviteUrls>>>
export type FleetInviteUrlsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Invite Urls List
 */

export function useFleetInviteUrls<TData = Awaited<ReturnType<typeof fleetInviteUrls>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInviteUrlsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInviteUrls>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInviteUrlsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Remove Fleet Invite Url
 */
export const destroyFleetInviteUrl = (
    fleetSlug: MaybeRefOrGetter<string>,
    token: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
token = toValue(token);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/invite-urls/${token}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetInviteUrlMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetInviteUrl>>, TError,{fleetSlug: string;token: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetInviteUrl>>, TError,{fleetSlug: string;token: string}, TContext> => {

const mutationKey = ['destroyFleetInviteUrl'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetInviteUrl>>, {fleetSlug: string;token: string}> = (props) => {
          const {fleetSlug,token} = props ?? {};

          return  destroyFleetInviteUrl(fleetSlug,token,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetInviteUrlMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetInviteUrl>>>

    export type DestroyFleetInviteUrlMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Remove Fleet Invite Url
 */
export const useDestroyFleetInviteUrl = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetInviteUrl>>, TError,{fleetSlug: string;token: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetInviteUrl>>,
        TError,
        {fleetSlug: string;token: string},
        TContext
      > => {
      return useMutation(getDestroyFleetInviteUrlMutationOptions(options), queryClient);
    }
